import { useMutation } from "@tanstack/react-query";
import { forgotPwd } from "../../apis/auth";

export function useForgotPassword() {
  const { mutate, data, error, status } = useMutation({
    mutationFn: ({ email }: { email: string }) => {
      return forgotPwd(email);
    },
  });

  return {
    forgotPassword: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
